import {RoleDTO} from 'src/types';

export type RoleKind = 'builtIn' | 'custom';

export const ROLE_KINDS: RoleKind[] = ['builtIn', 'custom'];

/**
 * Where a role came from: shipped with the platform, or written here.
 *
 * Deliberately not three. Protection is a different question about the same role - whether it can be
 * deleted, narrowed or left without a holder - and folding it in made a role that is both into one
 * that reads as neither: the platform's own role is built-in and protected at once, so a single badge
 * had to pick one and silently drop the other. Protection stays its own field, answered where it
 * matters, and this says only which of the two kinds a role is.
 */
export const roleKind = (role: RoleDTO): RoleKind => (role.builtIn ? 'builtIn' : 'custom');
